module.exports = __webpack_public_path__ + "static/img/2-6.b34e647.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/2-6.jpg
// module id = sN+g
// module chunks = 25